import { formatDateShort } from 'platform/utilities/date';
import React from 'react';
import { useSelector } from 'react-redux';
import { SCHEMA_LABELS } from '../../chapters/healthInsurance/planTypes';
import content from '../../locales/en/content.json';
import { generateParticipantNames } from '../../utils/helpers';

const TEXT_PRESENT = content['health-insurance--summary-date-present'];
const TEXT_NOT_SPECIFIED = content['health-insurance--summary-date-missing'];

const formatDateRange = (startDate, endDate) => {
  const start = startDate && formatDateShort(startDate);
  const end = endDate ? formatDateShort(endDate) : TEXT_PRESENT;
  return start ? `${start} - ${end}` : TEXT_NOT_SPECIFIED;
};

const HealthInsuranceSummaryCard = item => {
  const applicants = useSelector(state => state.form.data.applicants);
  const { insuranceType, effectiveDate, expirationDate } = item ?? {};
  return (
    <ul className="no-bullets">
      <li>
        <strong>Type:</strong> {SCHEMA_LABELS[insuranceType]}
      </li>
      <li>
        <strong>Dates:</strong> {formatDateRange(effectiveDate, expirationDate)}
      </li>
      <li>
        <strong>Policy members:</strong>{' '}
        {generateParticipantNames({ item, applicants })}
      </li>
    </ul>
  );
};

export default HealthInsuranceSummaryCard;
